import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "persistent": "",
      "max-width": "75%"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.formIsValid,
            "prepend-icon": "fa-save"
          },
          on: {
            "click": _vm.handleSave
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.name'),
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-account-selector', {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.accountId,
      callback: function ($$v) {
        _vm.accountId = $$v;
      },
      expression: "accountId"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "data-cy": "export_parent_id",
      "disabled": !_vm.accountId,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.accountId,
      "loadFullDtwinData": true,
      "sameTenant": "",
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.parentId,
      callback: function ($$v) {
        _vm.parentId = $$v;
      },
      expression: "parentId"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.title')) + "\n          ")]), _c(VExpansionPanelContent, [_vm.filterType === 'digitalTwin' ? _c('core-csv-export-search-digital-twins', {
    on: {
      "updated": _vm.updateFilter
    }
  }) : _c('core-csv-export-search-virtual-devices', {
    on: {
      "updated": _vm.updateFilter
    }
  }), _vm.searchTotalCount === 0 ? [_c(VDivider), _c(VAlert, {
    staticClass: "ma-0 mt-2 no-result-alert",
    attrs: {
      "color": "#F58C04",
      "icon": "fas fa-exclamation-circle",
      "elevation": "0",
      "dense": ""
    }
  }, [_c('em', [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCountNoDevicesAlert.title')))]), _c('br'), _vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCountNoDevicesAlert.message', {
    devices: _vm.filterType === 'digitalTwin' ? _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.digitalTwins') : _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.virtualDevices')
  })) + "\n              ")])] : [_vm._v("\n              " + _vm._s(_vm.searchTotalCountMessage) + "\n            ")]], 2)], 1)], 1)], 1)], 1), _vm.showStructureSection ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.selectCsvStructure')) + "\n            ")]), _c(VExpansionPanelContent, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.selectCsvStructureDescription')) + "\n              "), _c(VSwitch, {
    staticClass: "switch-dense",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.clusterPacketDataPerRow'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "inset": ""
    },
    model: {
      value: _vm.csvOptions.clusterPerPacket,
      callback: function ($$v) {
        _vm.$set(_vm.csvOptions, "clusterPerPacket", $$v);
      },
      expression: "csvOptions.clusterPerPacket"
    }
  }), _vm.csvOptions.clusterPerPacket ? _c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.allDriversVariables,
      "item-text": item => `${item.title}${` (${item.count} ${_vm.$i18n_t('Common.of')} ${_vm.drivers.length} ${_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.deviceDrivers')})`}`,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "hide-details": "",
      "multiple": "",
      "return-object": "",
      "small-chips": ""
    },
    model: {
      value: _vm.selectedDriversVariables,
      callback: function ($$v) {
        _vm.selectedDriversVariables = $$v;
      },
      expression: "selectedDriversVariables"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)] : _vm._e(), !_vm.showStructureSection || !_vm.csvOptions.clusterPerPacket ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.stateIdentifiers.title')) + "\n            ")]), _c(VExpansionPanelContent, [_c(VAutocomplete, {
    attrs: {
      "search-input": _vm.stateIdSearchInput,
      "items": _vm.stateIdentifiers,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.stateIdentifiers.label'),
      "item-text": item => `${item.key}-${item.valueType}`,
      "item-value": item => `${item.key}-${item.valueType}`,
      "multiple": "",
      "chips": "",
      "hide-details": "",
      "disabled": _vm.stateIdentifiers.length === 0
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.stateIdSearchInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.stateIdSearchInput = $event;
      },
      "change": function ($event) {
        _vm.stateIdSearchInput = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VCheckbox, {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "value": _vm.selectedStates.includes(`${item.key}-${item.valueType}`)
          }
        }), _vm._v("\n                  " + _vm._s(item.key) + " (" + _vm._s(item.valueType) + ") (" + _vm._s(item.statesCount) + "\n                  " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                  " + _vm._s(_vm.searchTotalCount) + "\n                  " + _vm._s(_vm.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.data.${_vm.filterType === 'digitalTwin' ? 'digitalTwins' : 'virtualDevices'}`)) + ")\n                ")];
      }
    }, {
      key: "selection",
      fn: function ({
        item
      }) {
        return [_c(VChip, [_vm._v("\n                    " + _vm._s(item.key) + " (" + _vm._s(item.valueType) + ") (" + _vm._s(item.statesCount) + "\n                    " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                    " + _vm._s(_vm.searchTotalCount) + "\n                    " + _vm._s(_vm.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.data.${_vm.filterType === 'digitalTwin' ? 'digitalTwins' : 'virtualDevices'}`)) + ")\n                  ")])];
      }
    }], null, false, 3497463306),
    model: {
      value: _vm.selectedStates,
      callback: function ($$v) {
        _vm.selectedStates = $$v;
      },
      expression: "selectedStates"
    }
  })], 1)], 1)], 1)], 1)], 1)] : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.titleNonScheduled')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-dateTime-picker-flat', {
    attrs: {
      "initialRange": "now-24h",
      "isRange": ""
    },
    on: {
      "date:picked": _vm.updateTimeRange
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.title')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VSelect, {
    attrs: {
      "items": _vm.dataAggregationItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.dataAggregationObj,
      callback: function ($$v) {
        _vm.dataAggregationObj = $$v;
      },
      expression: "dataAggregationObj"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, [_c(VExpansionPanels, {
    attrs: {
      "value": 1
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.extendedCsvFormattingOptions')) + "\n          ")]), _c(VExpansionPanelContent, [_c('core-csv-export-formatting-options', {
    attrs: {
      "filterType": _vm.filterType,
      "customProperties": _vm.customProperties,
      "references": _vm.references,
      "devicesCount": _vm.searchTotalCount,
      "driversCount": _vm.drivers.length,
      "selectedDriversVariables": _vm.selectedDriversVariables
    },
    model: {
      value: _vm.csvOptions,
      callback: function ($$v) {
        _vm.csvOptions = $$v;
      },
      expression: "csvOptions"
    }
  })], 1)], 1)], 1)], 1)], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };